<template>
  <v-layout row justify-center>
    <v-dialog v-model="displayForm" persistent max-width="980px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card v-if="customerId">
          <v-card-title>
            <span class="headline">Add Credit Card</span>
          </v-card-title>
          <v-card-text>
            <v-alert :value="message" type="error" transition="scale-transition">{{ message }}</v-alert>
            <v-container fluid>
              <v-layout align-center justify-start row>
                <v-flex xs3>Type:</v-flex>
                <v-flex xs9>
                  <v-select
                    v-model="model.type"
                    label="Type"
                    :rules="mandatoryRules"
                    :items="cardTypes"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout align-center justify-start row>
                <v-flex xs3>Number:</v-flex>
                <v-flex xs9>
                  <v-text-field v-model="model.number" :rules="mandatoryRules" label="Number"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout align-center justify-start row>
                <v-flex xs3>Month:</v-flex>
                <v-flex xs3>
                  <v-select
                    v-model="model.expMonth"
                    label="expMonth"
                    :rules="mandatoryRules"
                    :items="months"
                  ></v-select>
                </v-flex>
                <v-flex xs3>Year:</v-flex>
                <v-flex xs3>
                  <v-select
                    v-model="model.expYear"
                    label="expYear"
                    :rules="mandatoryRules"
                    :items="years"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout align-center justify-start row>
                <v-flex xs3>Security:</v-flex>
                <v-flex xs9>
                  <v-text-field v-model="model.security" :rules="mandatoryRules" label="Security"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancel()" :disabled="loading">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="create()" :disabled="loading">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
function getDefaultData() {
  return {
    model: {
      type: null,
      number: null,
      expMonth: null,
      expYear: null,
      security: null
    },
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    loading: false,
    valid: false,
    message: null,
    months: [
      { text: "01 - January", value: "01" },
      { text: "02 - Febuary", value: "02" },
      { text: "03 - March", value: "03" },
      { text: "04 - April", value: "04" },
      { text: "05 - May", value: "05" },
      { text: "06 - June", value: "06" },
      { text: "07 - Jully", value: "07" },
      { text: "08 - August", value: "08" },
      { text: "09 - September", value: "09" },
      { text: "10 - October", value: "10" },
      { text: "11 - November", value: "11" },
      { text: "12 - December", value: "12" }
    ],
    cardTypes: [
      { text: "Visa", value: "visa" },
      { text: "Mastercard", value: "mastercard" },
      { text: "Amex", value: "amex" }
    ]
  };
}
export default {
  props: {
    open: {
      type: Boolean
    },
    customerId: {
      type: Number
    }
  },
  data: getDefaultData,
  computed: {
    displayForm: function() {
      return this.open;
    },
    years: function() {
      let year = [];
      let now = new Date().getFullYear();
      for (let index = 0; index < 20; index++) {
        year.push("" + (now + index));
      }
      return year;
    }
  },
  methods: {
    create() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch("clients/addCard", {
            customerId: this.customerId,
            model: this.model
          })
          .then(result => {
            if (result.id) {
              this.$emit("add", result.id);
              this.resetForm();
            } else {
              for (let index = 0; index < result.length; index++) {
                const error = result[index];
                if (error.type == "invalidFields") {
                  this.message =
                    "The credit card information are false, please check and retry";
                }
              }
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    cancel() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    }
  }
};
</script>

<style>
</style>
